import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Spread from '@/views/page/Spread'

import Login from '@/views/auth/Login'
import Logout from '@/views/auth/Logout'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.APP_BASE,
  routes: [
    { path: '/', name: 'Start', component: require('@/views/service/Start').default, meta: { service: true } },
    {
      path: '/book/:id',
      component: require('@/views/book/Book').default,
      children: [
        {
          path: '',
          component: require('@/views/book/BookStart').default,
          name: 'BookStart'
        },
        {
          path: 'page/:pageNumber',
          component: require('@/components/Layout').default,
          children: [
            { path: '', name: 'Page', component: Spread }
          ]
        }
      ]
    },
    { path: '/login', name: 'Login', component: Login },
    { path: '/logout', name: 'Logout', component: Logout, meta: { service: true } },
    { path: '/loggedout', name: 'LoggedOut', component: require('@/views/service/LoggedOut').default, meta: { service: true } },
    { path: '/noaccess', name: 'NoAccess', component: require('@/views/service/NoAccess').default, meta: { service: true } },
    { path: '/loading', name: 'Loading', component: require('@/views/service/Loading').default, meta: { service: true } },
    { path: '*', name: 'NotFound', component: require('@/views/service/NotFound').default, meta: { service: true } }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.service) {
    next()
  } else if (to.name !== 'Login' && !store.getters.isLoggedIn) {
    next({ name: 'Login', query: { redirect: to.path, bookId: to.params.id, jwt: to.query.jwt } })
  } else {
    if (to.params.id && store.getters.currentUser && store.getters.currentUser.book_id !== to.params.id) {
      next({ name: 'Login', query: { redirect: to.path, bookId: to.params.id, jwt: to.query.jwt } })
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js